import { type FC, useContext } from 'react';
import { useContentfulInspectorMode } from '@contentful/live-preview/react';

// helpers
import { NEXT_PUBLIC_IS_PREVIEW } from 'src/env';
import { sanitizePreviewHtml } from 'src/lib/sanitize-preview-html';
import { replaceHrefValueWithLocale, sanitizeHtml } from 'src/lib/utils';

// contexts
import { LocaleContext } from 'src/contexts';

interface Props {
  body: string;
  entryId?: string;
  as?: 'div' | 'span';
  className?: string;
}

const RawHtml: FC<Props> = ({ body, entryId, as = 'div', className }) => {
  const Wrapper = as;
  const locale = useContext(LocaleContext);
  const inspectorProps = useContentfulInspectorMode({ entryId });
  const html = replaceHrefValueWithLocale({ locale, str: sanitizeHtml(body) });

  return (
    <Wrapper
      {...(entryId ? inspectorProps({ fieldId: 'body' }) : null)}
      className={className}
      dangerouslySetInnerHTML={{
        __html: NEXT_PUBLIC_IS_PREVIEW ? sanitizePreviewHtml(html) : html,
      }}
    />
  );
};

export default RawHtml;
